import React from 'react';
import { Mic, Layout, FileText, FileType, ArrowRight } from 'lucide-react';

function AccueilTab({ onNavigateToTab }) {
  const cards = [
    {
      id: 'dictaphone',
      icon: Mic,
      title: 'Dictaphone',
      description: 'Dictez vos rapports, lettres, ordonnances, etc. comme vous le feriez à un·e secrétaire. Voxia transcrit, structure et met en forme vos dictées selon vos habitudes. Vous pouvez dicter depuis votre téléphone, ordinateur, ou même un dictaphone Philips DPM.',
      color: 'primary'
    },
    {
      id: 'modeles',
      icon: Layout,
      title: 'Modèle de rapport',
      description: 'Le modèle définit comment l\'IA structure votre dictée : consultation, lettre, note, email, courrier... Vous pouvez choisir le modèle avant de dicter, ou laisser Voxia le détecter automatiquement.',
      color: 'purple'
    },
    {
      id: 'rapports',
      icon: FileText,
      title: 'Rapport',
      description: 'Le rapport est le document final généré par l\'IA à partir de votre dictée. Vous pouvez le relire, le corriger si nécessaire, et l\'utiliser pour améliorer le modèle pour votre prochaine dictée.',
      color: 'green'
    },
    {
      id: 'templates',
      icon: FileType,
      title: 'Template Word',
      description: 'Importez vos propres templates Word pour générer automatiquement un document médical complet, écrit comme vous l\'avez dicté et selon votre style visuel.',
      color: 'brown'
    }
  ];

  return (
    <div className="guide-welcome">
      <div className="guide-welcome-grid">
        {cards.map(card => {
          const Icon = card.icon;
          return (
            <button
              key={card.id}
              className={`guide-welcome-card guide-welcome-card-${card.color}`}
              onClick={() => onNavigateToTab && onNavigateToTab(card.id)}
            >
              <div className={`guide-welcome-icon-wrapper ${card.color}`}>
                <Icon size={28} />
              </div>
              <div className="guide-welcome-content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
              <ArrowRight className="guide-welcome-arrow" size={20} />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default AccueilTab;
